export default __webpack_public_path__ + "static/media/cloud-one.fcc9a8d0.svg";